import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { RotateCcw } from 'lucide-react-native';
import { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';

/** 值得重练 under a line of the transcript: opens its moment replay. */
export const RetryTag = memo(({ onPress }: { onPress: () => void }) => {
  const { rpx } = useResponsiveContext();
  return (
    <TouchableOpacity
      accessibilityRole="button"
      onPress={onPress}
      hitSlop={6}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: rpx(2),
        borderRadius: rpx(999),
        borderWidth: 1,
        borderColor: aiColors.border,
        backgroundColor: aiColors.card,
        paddingHorizontal: rpx(8),
        paddingVertical: rpx(2),
      }}
    >
      <RotateCcw size={rpx(10)} color={aiColors.foreground} />
      <Typography.Text size={rpx(10)} bold color={aiColors.foreground}>
        值得重练
      </Typography.Text>
    </TouchableOpacity>
  );
});
